import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  ATHLETE_INDEX,
  ATHLETE_CLUB_INDEX,
  ATHLETE_PROFILE_VIEWS_GET,
  ATHLETE_EVENTS,
  ATHLETE_VIDEOS,
  UPDATE_ATHLETE,
  CREATE_ATHLETE,
  ATHLETE_IMAGES,
  UPLOAD_ATHLETE_IMAGES,
  DELETE_ATHLETE_IMAGES,
  SCOUTING_ATHLETE_IMAGES,
  UPDATE_ATHLETE_TEAM_PLAYED,
  UPDATE_BLOCKED_GROUP,
  ATHLETE_SHOW
} from "@/utils/api-url";

const GRADUATION_CONFIG = [
  {
    label: "College Transfer",
    value: "College Transfer"
  },
  {
    label: "2030",
    value: "2030"
  }
];

class Athlete extends Base {
  constructor(params = {}) {
    super(params);

    this.id = params["_id"] || this.Id || this.id || "";
    this.key = params["_id"] || this._id || this.Id || this.key || "";
    this.athleteName = params["athletename"] || this.athletename || "";
    this.profileImage =
      (params["profile"] && params["profile"]["image"]) ||
      this.profileImage ||
      "";
    this.state =
      (params["state"] && params["state"]["name"]) || this.state || "";
    this.stateId =
      this.stateId || (params["state"] && params["state"]["_id"]) || null;
    this.city = params["city"] || this.city || "";
    this.graduationYear = params["graduationYear"] || this.graduationYear || "";
    this.birthYear = params["birthYear"] || this.birthYear || "";
    this.birthMonth = params["birthMonth"] || this.birthMonth || "";
    this.birthDay = params["birthDay"] || this.birthDay || "";
    this.battingHand =
      (params["battingHand"] && params["battingHand"]["name"]) ||
      this.battingHand ||
      "";
    this.battingHandId =
      (params["battingHand"] && params["battingHand"]["_id"]) ||
      this.battingHandId ||
      "";
    this.throwingHandId =
      (params["throwingHand"] && params["throwingHand"]["_id"]) ||
      this.throwingHandId ||
      "";
    this.battingAverage =
      params["battingAverage"] ||
      this.battingAverage ||
      this.getBattingAverage(params["battingAverage"]);
    this.commonBattingInfo =
      `${this.battingHand} / ${this.battingAverage}` || "";
    this.throwingHand =
      (params["throwingHand"] && params["throwingHand"]["name"]) ||
      this.throwingHand ||
      "";
    this.videoFlag = params["videoFlag"] || this.videoFlag || "";
    this.division = params["division"] || this.division || "";
    this.gpa = params["gpa"] || this.gpa || "";
    this.committed = params["committed"] || this.committed || false;
    this.institutionName = params["collegeName"] || params["clubName"] || "";
    this.divisionName =
      (params["division"] && params["division"]["name"]) || "";
    this.coachname = params["coachname"] || "";
    this.position = (params["position"] && params["position"]) || [];
    this.positionIds =
      this.positionIds ||
      (params["position"] &&
        typeof params["position"] !== "string" &&
        params["position"].map(item => item._id)) ||
      [];
    this.count = params["count"] || 0;
    this.teamPlayedData = params["teamPlayedData"] || this.teamPlayedData || [];
    this.major1 =
      (params["majors"] && params["majors"][0]) || this.major1 || "";
    this.major2 =
      (params["majors"] && params["majors"][1]) || this.major2 || "";
    this.major3 =
      (params["majors"] && params["majors"][2]) || this.major3 || "";
    this.remainingYears = params["remainingYears"] || this.remainingYears || "";
    this.registerPageCompleted =
      params["register_page_completed"] ||
      params["registerPageCompleted"] ||
      this.registerPageCompleted ||
      0;
    this.countryId =
      (params["country"] && params["country"]["_id"]) || this.countryId || "";
    this.images = params["images"] || this.images || [];
    this.profileType = params["profileType"] || this.profileType || "";
    this.heightInFeet = params["heightInFeet"] || this.heightInFeet;
    this.heightInInch = params["heightInInch"] || this.heightInInch;
    this.viewBy = params["viewBy"] || this.viewBy || "";
    this.favC = params["fav_c"] || this.favC || false;
    this.viewByInstitution =
      (params["viewBy"] && params["viewBy"]["CollegeId"]) ||
      (params["viewBy"] && params["viewBy"]["clubId"]) ||
      "";
  }

  getBattingAverage(battingAverage) {
    if (battingAverage && battingAverage.toString().includes("sec"))
      return battingAverage;
    return (battingAverage && `${battingAverage}sec`) || "";
  }

  static resourceName() {
    return "Athlete";
  }

  static index(params) {
    const profileId = this.profileId();
    return apiDispatcher(ATHLETE_INDEX(params, profileId));
  }

  static create(params) {
    const profileId = this.profileId();
    return apiDispatcher(CREATE_ATHLETE(params, profileId));
  }

  static update(params) {
    return apiDispatcher(UPDATE_ATHLETE(params, params.id));
  }

  static updateAthleteImage() {
    return apiDispatcher(UPDATE_ATHLETE_IMAGE(params, params.id));
  }

  static clubIndex(params) {
    const profileId = this.profileId();
    return apiDispatcher(ATHLETE_CLUB_INDEX(params, profileId));
  }

  static getProfileViews(params) {
    const profileId = this.profileId();
    return apiDispatcher(ATHLETE_PROFILE_VIEWS_GET(params, profileId));
  }

  static getAthleteEvents(params) {
    return apiDispatcher(ATHLETE_EVENTS(params, params.profileId));
  }

  static getAthleteVideos(params) {
    const profileId = this.profileId();
    return apiDispatcher(ATHLETE_VIDEOS(params, profileId));
  }

  static updateAthleteImages(params) {
    return apiDispatcher(ATHLETE_IMAGES(params));
  }

  static uploadAthleteImages(params) {
    return apiDispatcher(UPLOAD_ATHLETE_IMAGES(params));
  }

  static deleteAthleteImages(params) {
    return apiDispatcher(DELETE_ATHLETE_IMAGES(params));
  }

  static uploadScoutingImages(params) {
    return apiDispatcher(SCOUTING_ATHLETE_IMAGES(params));
  }

  static updateAthleteTeamPlayed(params) {
    return apiDispatcher(UPDATE_ATHLETE_TEAM_PLAYED(params));
  }

  static show(params) {
    return apiDispatcher(ATHLETE_SHOW(params, params.profileId));
  }

  static graduationConfig() {
    return window.exceptClubCoach()
      ? [
          {
            label: "College Transfer",
            value: "College Transfer"
          },
          ...this.nYears(10)
        ]
      : [...this.nYears(10)];
  }

  static updateBlockedGroup(params) {
    return apiDispatcher(UPDATE_BLOCKED_GROUP(params));
  }

  static academicValidationRules = {
    highSchool: [{ required: false, message: "Highschool name is required" }],
    gpa: [{ required: false, message: "Gpa is required" }],
    satScore: [{ required: false, message: "Sat score is required" }],
    actScaleScore: [{ required: false, message: "Act score is required" }]
  };

  static detailsValidationRules = {
    battingHand: [{ required: true, message: "Batting hand is required" }],
    battingHandId: [{ required: true, message: "Batting hand is required" }],
    position: [{ required: true, message: "Position is required" }],
    positionIds: [{ required: true, message: "Position is required" }],
    throwingHand: [{ required: true, message: "Throwing hand is required" }],
    throwingHandId: [{ required: true, message: "Throwing hand is required" }],
    graduationYear: [
      { required: true, message: "Graduation year is required" }
    ],
    remainingYears: [{ required: true, message: "Remaning years is required" }]
  };

  static basicValidationRules = {
    athletename: [{ required: true, message: "Athlete name is required" }],
    heightInFeet: [{ required: true, message: "Height is required" }],
    heightInInch: [{ required: true, message: "Height is required" }],
    birthDay: [{ required: true, message: "Birth Day is required" }],
    birthMonth: [{ required: true, message: "Birth Month is required" }],
    birthYear: [{ required: true, message: "Birth Year is required" }],
    city: [{ required: true, message: "City is required" }],
    stateId: [{ required: true, message: "State is required" }],
    countryId: [{ required: true, message: "Country is required" }]
  };

  static YEARS_REMANING = [
    {
      label: "1",
      value: 1
    },
    {
      label: "2",
      value: 2
    },
    {
      label: "3",
      value: 3
    },
    {
      label: "4",
      value: 4
    }
  ];

  static searchConfig = () => [
    {
      component: "BaseInput",
      placeholder: "Athlete Name",
      column: "q",
      searchType: "query",
      additionalData: { searchField: "athletename" },
      gridComponent: "one"
    },
    {
      component: "BaseSelect",
      placeholder: "Year Born",
      column: "birthYear",
      allowClear: true,
      mode: "year",
      labelPath: "label",
      valuePath: "value",
      items: this.nPastYears(30),
      searchType: "normal",
      gridComponent: "three",
      optionFilterProp: "children",
      showSearch: true,
      filterOption: true
    },
    {
      component: "BaseInput",
      placeholder: "City",
      column: "q1",
      searchType: "query",
      additionalData: { searchField1: "city" },
      gridComponent: "two"
    },
    {
      component: "BaseTaxonomySelect",
      resource: "playerPosition",
      type: "Player Position",
      placeholder: "Position",
      mode: "multiple",
      allowClear: true,
      column: "position",
      searchType: "normal",
      gridComponent: "four"
    },
    {
      component: "BaseSortedTaxonomySelect",
      resource: "playerState",
      type: "Player State",
      placeholder: "State",
      allowClear: true,
      column: "state",
      filterByLabel: ["International"],
      searchType: "normal",
      gridComponent: "five",
      optionFilterProp: "children",
      showSearch: true,
      filterOption: true
    },
    {
      component: "BaseSelect",
      placeholder: "Graduation Year",
      column: "graduationYear",
      items: this.graduationConfig(),
      allowClear: true,
      searchType: "normal",
      labelPath: "label",
      valuePath: "value",
      gridComponent: "six"
    },
    {
      component: "BaseTaxonomySelect",
      resource: "collegeGpa",
      type: "College GPA",
      placeholder: "GPA",
      allowClear: true,
      column: "gpa",
      split: ["gpa[lte]", "gpa[gte]"],
      valuePath: "name",
      labelPath: "name",
      searchType: "exceptionalSplit",
      gridComponent: "seven"
    },
    {
      component: "BaseTaxonomySelect",
      resource: "battingHand",
      type: "Bats",
      allowClear: true,
      placeholder: "Batting Hand",
      column: "battingHand",
      gridComponent: "eleven",
      searchType: "normal"
    },
    {
      component: "BaseTaxonomySelect",
      resource: "throwingHand",
      type: "Throws",
      allowClear: true,
      placeholder: "Throwing Hand",
      column: "throwingHand",
      gridComponent: "ten",
      searchType: "normal"
    },
    {
      component: "BaseCheckbox",
      label: "Video Only",
      searchType: "checkbox",
      gridComponent: "thirteen",
      column: "videoFlag"
    },
    {
      component: "BaseRadioGroup",
      items: [
        { label: "Yes", value: true },
        { label: "No", value: false }
      ],
      column: "committed",
      searchType: "radio",
      gridComponent: "fourteen",
      label: "Committed to College"
    },
    {
      component: "BaseSelect",
      placeholder: "Home to 1st Time",
      column: "firstToHomeTime",
      searchType: "normal",
      allowClear: true,
      gridComponent: "eight",
      items: this.homeTo1stData,
      humanizeLabel: false
    },
    {
      component: "BaseSelect",
      placeholder: "2nd to Home Time",
      column: "secondToHomeTime",
      allowClear: true,
      gridComponent: "nine",
      searchType: "normal",
      items: this.homeTo2ndData,
      humanizeLabel: false
    },
    {
      component: "BaseButton",
      class: "btn btn-default primary-button-extra-class",
      type: "primary",
      searchType: "Submit",
      gridComponent: "fifteen",
      label: "Search",
      clickable: true
    }
  ];

  static yearsRemaningConfig = {
    component: "BaseSelect",
    items: Athlete.YEARS_REMANING,
    placeholder: "Years Remaning To Play",
    labelPath: "label",
    valuePath: "value",
    column: "yearsRemaning",
    allowClear: true,
    gridComponent: "twelve",
    searchType: "normal"
  };

  static homeTo1stData = [
    "Below 2.8",
    "2.8 - 3.0",
    "3.1 - 3.2",
    "3.3 - 3.4",
    "3.5 & Above"
  ];

  static homeTo2ndData = [
    "Below 5.1",
    "5.1 - 5.3",
    "5.4 - 5.6",
    "5.7 - 5.9",
    "6.0 & Above"
  ];
}

export default Athlete;
